export default __webpack_public_path__ + "static/media/profile.7093ad59.svg";